export default "__VITE_ASSET__vsOle9KQ__"